import { action, computed, observable, makeObservable } from 'mobx';
import { AnalyticsApi } from './API';

class AnalyticsStore {
  @observable data = [];

  @observable chartData = [];

  constructor() {
    makeObservable(this);
  }

  @computed get getData() {
    return this.data;
  }

  @computed get getChartData() {
    return this.chartData;
  }

  @action
  reset = () => {
    this.data = [];
    this.chartData = [];
  };

  @action
  resetChartData = () => {
    this.chartData = [];
  };

  @action setChartData = async (symbol, f) => {
    const d = new Date();

    const getFrame = {
      D1: {
        from: d.setHours(-24),
        frame: 'H1',
      },
      W1: { from: d.setHours(-168), frame: 'H1' },
      MN: { from: d.setMonth(d.getMonth() - 1), frame: 'D1' },
      MN3: { from: d.setMonth(d.getMonth() - 3), frame: 'D1' },
    };

    const response = await AnalyticsApi.getChartData(
      symbol,
      getFrame[f].frame,
      {
        from: getFrame[f].from,
        to: Date.now(),
      }
    );
    this.chartData = response ? response.data : [];
  };

  @action setData = async (frame, group) => {
    const response = await AnalyticsApi.getAnalytics(frame, group);
    this.data = Array.isArray(response?.data) ? response?.data : [];
    return Array.isArray(response?.data) ? response.data : [];
  };
}

export default new AnalyticsStore();
